<template>
    <div class="customer-form entity-form" @click="(e)=>{e.stopPropagation()}">
        <form @submit.prevent="submitCustomer">
            <div class="form-heading">
                <button class="button-primary button-primary__thin" type="button" @click="cancelForm">{{$t('form.customer.cancel')}}</button>
                <div v-if="reference < 0" class="form-title">{{$t('form.customer.newCust')}}</div>
                <div v-else class="form-title">{{$t('form.customer.editCust')}}</div>
                <button class="button-primary button-primary__inverse button-primary__thin" type="submit">{{$t('form.customer.save')}}</button>
            </div>

            <div class="flex-column" style="margin-top: 16px">
                <div v-if="errors.length > 0" style="height: 30px;margin-top: 8px; font-size: 12px; color: red">
                    {{errors}}
                </div>
                <div class="form-row flex-row">
                    <div class="form-row-element">
                        <BaseInput v-model="firstName" :label="$t('form.customer.firstName')" placeholder=""/>
                    </div>
                    <div  class="form-row-element">
                        <BaseInput v-model="lastName" :label="$t('form.customer.lastName')" placeholder=""/>
                    </div>

                </div>
                <div class="form-row flex-row">
                    <div class="form-row-element">
                        <BaseInput v-model="mobile" :label="$t('form.customer.phoneNo')" placeholder=""/>
                    </div>

                </div>
                <div class="form-row flex-row">
                    <div class="form-row-element">
                        <BaseInput v-model="email" :label="$t('form.customer.email')" placeholder=""/>
                    </div>

                </div>
                <div class="form-row flex-row">
                    <div class="form-row-element">
                        <BaseInput v-model="primaryAddress.addressLine1" :label="$t('form.customer.addressLine1')" placeholder=""/>
                    </div>

                </div>
                <div class="form-row flex-row">
                    <div class="form-row-element-small">
                        <BaseInput v-model="primaryAddress.postCode" :label="$t('form.customer.postcode')" placeholder=""/>
                    </div>
                    <div class="form-row-element">
                        <BaseInput v-model="primaryAddress.postLocation" :label="$t('form.customer.city')" placeholder=""/>
                    </div>

                </div>
                <div class="form-row flex-row" style="padding-top: 18px;">
                <div class="form-row-element-narrow">
                    <CheckBoxInput v-model="isHost" :label="$t('form.customer.isHost')"/>
                </div>

            </div>
                <div class="form-row flex-row">
                    <div class="form-row-element-narrow">
                        <CheckBoxInput v-model="isVip" :label="$t('form.customer.isVip')"/>
                    </div>

                </div>
            </div>
         </form>
    </div>
</template>

<script>
 import * as types from '@/store/mutations'
 import BaseInput from "./inputs/BaseInput.vue"
 import CheckBoxInput from "./inputs/CheckBoxInput.vue"
 export default {
     name: "CustomerForm",
     components: { CheckBoxInput, BaseInput },
     data() {
         return {
             id: -1,
             isHost: this.$store.state.customers.prefill.date || false,
             isVip: false,
             isDealer: false,
             isCustomer: true,
             firstName: this.$store.state.customers.prefill.first,
             lastName: this.$store.state.customers.prefill.last,
             mobile: '',
             email: '',
             primaryAddress: {
                 addressLine1: '',
                 postCode: '',
                 postLocation: '',
             },
             redirect: this.$store.state.customers.prefill.redirect,
             additionalData: this.$store.state.customers.prefill.date,
             errors: []
         }
     },
     props: {
         reference: { type: Number, default: -1 }
     },
     emits: ['customer-submitted', 'form-closed'],
     created(){
         this.$store.commit(types.CLEAR_CREATECUSTOMER_PREFILL)
     },
     mounted(){
         this.$store.dispatch('getCustomer', this.reference).then((res)=>{
             this.id = res.id
             this.isHost = res.isHost
             this.isVip = res.isVIP
             this.isDealer = res.isDealer
             this.isCustomer = res.isCustomer
             this.firstName = res.firstName
             this.lastName = res.lastName
             this.mobile = res.mobile
             this.email = res.email

             if (res.primaryAddress) {
                 this.primaryAddress = res.primaryAddress
             } else {
                 this.primaryAddress = {
                     addressLine1: '',
                     postCode: '',
                     postLocation: '',
                 }
             }
             console.log(res)
         }).catch((e)=>{
             console.log(e)
         })
     },
     methods: {
         submitCustomer(){
             let customer = {
                 id: this.id,
                 isHost: this.isHost,
                 isVip: this.isVip,
                 isDealer: this.isDealer,
                 isCustomer: this.isCustomer,
                 firstName: this.firstName,
                 lastName: this.lastName,
                 mobile: this.mobile,
                 email: this.email,
                 primaryAddress: {
                     addressLine1: this.primaryAddress.addressLine1,
                     postCode: this.primaryAddress.postCode,
                     postLocation: this.primaryAddress.postLocation,
                 }
             }
             this.$emit('customer-submitted',{customer:customer,redirect:this.redirect, date:this.additionalData} )
         },
         cancelForm(){
             this.$emit('form-closed')
         }
     }
 }
</script>

<style scoped>

</style>
